module.exports = {
  environment: 'test',
  tokenCredentials: {
    user: '',
    pass: ''
  },
  environmentMap: {
    'hanvb': 'QQD3VBHA',
    'bankhaus-jungholz': 'QQD3BAJU',
    'berenberg': 'QQD3BERE',
    'sparkasse-bremen': 'QQD3SPBR',
    'lunis': 'QQD3LN15',
    'finum': 'QQD3F1NU',
    'olb': 'QQD3OLBA',
    'owl': 'QQD3VPHD',
    'netfonds': 'QQD3N3F0',
    'test': 'QQD3D3M0',
    'verbundvolksbank-owl': 'QQD3VPHD',
    'volksbank-weinheim': 'QQD3D3M0',
    'fugger': 'QQD3FUGG',
    'kskk': 'QQD3KSKK',
    'nordlblu': 'QQD3NLBU',
    'deutsche-bank': 'QQD3DEBA',
    'blsk': 'QQD3BLSK',
    'emissionstool': 'QQD33M15',
    'abn-amro': 'QQD3ABNA',
    'bnp': 'QQD3BNPP',
    'bnprfq': 'QQD3BNPR',
    'raiffeisen-centrobank': 'QQD3RCBA',
    'lbbw': 'QQD3LBBW',
    'single-user-certificate-environment': 'QQD351NG',
    'weberbank': 'QQD3W3B3',
    'nationalbank': 'QQD3NABA',
    'bethmannbank': 'QQD3BEBA',
    'commerzbank': 'QQD3COM3',
    'bison': 'QQD3B2SN',
    'bison-demo': 'QQD3B1SN',
    'degussa-bank': 'QQD3D3GU',
    'sska': 'QQD3ABRG' ,
    'sparkasse-dresden': 'QQD30SDD',
    'sparkasse-langenfeld': 'QQD3L4NG',
    'sparkasse-jena': 'QQD3J3N4',
  }
}



// WEBPACK FOOTER //
// ./src/appConfig.js